import Tween from "tween.ts"
import Animation from "../../../../../src/animation/Animation";
import { Coord } from "../../../../../src/types/Interface";
import AngleBg from "../entities/AngleBg";


export default class DrawAngleBgAnim extends Animation {
  private Anim = Animation.getInstance();
  private isStopped = false;
  AngleBg: AngleBg;
  cCoord: Coord;
  constructor(AngleBg: AngleBg, radian: number, cCoord: Coord, onComp: () => void, resolve: () => void) {
    super();
    this.AngleBg = AngleBg;
    this.cCoord = cCoord;

    this.rootEventBus.on(this.EnumRootEventBus.cancelledCircleAnim, () => this.isStopped = true);

    if(this.getIsCancelled()) {
      resolve();
      return 
    };
    
    new Tween.Tween({...AngleBg})
      .to({ startRadian: radian }, 2000)
      .easing(Tween.Easing.Linear.None)
      .onUpdate((ABg: AngleBg) => {
        
        if(this.isStopped) {
          AngleBg.clear();
          resolve();
          return
        }
        this.AngleBg.draw(ABg.startRadian, ABg.endRadian);
        
      })
      .onComplete(() => onComp())
      .start()
  }
}